import {combineReducers} from "redux";
import session from "./session/reducer";

export default combineReducers({
    session,
});
